import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import PartnerServiceBookingCalendar from '../components/partner-service-booking-calendar';
import {getOwnedFieldBookings, showBookingModal, hideBookingModal, newOwnedFieldBooking, saveServiceBooking, ownedFieldBookingSelected, deleteServiceBooking, ownedFieldSlotSelected, bookingMultiSlotsSelected, getOwnedFieldSlots} from '../actions/partner';
import {showMessage} from '../actions/messages';
import {createPartnerBookingDraft} from '../util/partner-booking-roster';

const mapStateToProps = ({partner: {ownedService, ownedServices, isBookingModalVisible, ownedFieldSlots, ownedFieldSlot, ownedFieldBookings, ownedFieldBooking, bookingSlots}, login: {token, profile}}) => ({
  profile,
  ownedService,
  ownedServices,
  isBookingModalVisible,
  isLogged: token !== null,
  ownedFieldSlots,
  ownedFieldSlot,
  ownedFieldBookings,
  ownedFieldBooking,
  bookingSlots
});

const mapDispatchToProps = dispatch => ({
  eventSelected: ev => {
    if (ev.slot.state === 'reserved') {
      dispatch(showMessage('CALENDAR', 'CALENDAR_CANNOT_MODIFY_RESERVED_EVENT'));
    } else if (new Date(ev.slot.startDatetime) < Date.now() && ev.slot.bookingId === null) {
      dispatch(showMessage('BOOKINGS', 'BOOKING_EVENT_HAS_PASSED'));
    } else if (ev.slot.state === "unavailable") {
        dispatch(showMessage('BOOKINGS', 'BOOKING_EVENT_UNAVAILABLE'));
    } else if (ev.slot.bookingId) {
      dispatch(ownedFieldSlotSelected(ev.slot));
      dispatch(ownedFieldBookingSelected(ev.booking));
      if (ev.booking !== null && ev.booking !== undefined) {
        dispatch(showBookingModal());
      }
      else{
        dispatch(showMessage('BOOKINGS', 'LOADING_DATA_IN_PROGRESS'));
      }
    } else {
      dispatch(ownedFieldSlotSelected(ev.slot));
      dispatch(newOwnedFieldBooking({...createPartnerBookingDraft(ev.slot), slots: [ev.slot.slotId]}));
      dispatch(showBookingModal());
    }
  },
  bookingMultiSlots: slots => {
    dispatch(bookingMultiSlotsSelected(slots));
    dispatch(newOwnedFieldBooking({...createPartnerBookingDraft(null), slots: slots.map(s => s.slotId)}));
    dispatch(showBookingModal());
  },
  hideBookingModal: () => {
    dispatch(hideBookingModal());
  },
  saveBooking: booking => {
    dispatch(saveServiceBooking(booking));
  },
  deleteBooking: (serviceId, bookingId) => {
    dispatch(deleteServiceBooking(serviceId, bookingId));
  },
  showMessage: (title, body) => {
    dispatch(showMessage(title, body));
  },
  getSlotsByWeek: serviceId => targetDate => {
    dispatch(getOwnedFieldBookings(targetDate, 'WEEK', 'service'));
    dispatch(getOwnedFieldSlots(serviceId, true, 'service', targetDate, 'WEEK'));
  }
});

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps
)(PartnerServiceBookingCalendar));
